var $6d1fc8e84d8165e1$exports = {};
$6d1fc8e84d8165e1$exports = {
  "Empty": "Vuoto"
};
export { $6d1fc8e84d8165e1$exports as default };